const state = {
  connected: false,
  error: null,
  chatMessages: [],
  secs: null,
  drivingDirection: "---",
  mappingState: "idle",
  harvestingState: "idle",
  harvestingEta: "n/a",
  harvestingProgress: "n/a",
  harvestingBoxes: 0,
  gotoX: null,
  gotoY: null,
  gotoCommand: null,

  sprayingState: {
    SprayerRoverStatus: "Stop",
    SprayedRows: 0,
    SprayedEta: 0,
    SprayendPercentage: 0,
    SprayRate: 0,
    SprayTankError: false,
    SprayPumpError: false,
    SprayValveError: false,
  },

  diagnostics: {
    speed: 0,
    battery: 0,
    timeLeft: 0,
  },
};

const getters = {
  displayMessages: (state) => state.chatMessages,
};

const actions = {
  connectionOpened({ commit }) {
    commit("SET_CONNECTION", true);
  },
  connectionClosed({ commit }) {
    commit("SET_CONNECTION", false);
  },
  connectionError({ commit }, error) {
    commit("SET_ERROR", error);
  },
  setAttribute({ commit }, value) {
    commit("SET_ATTRIBUTE", value);
  },
  setSprayingAttribute({ commit }, value) {
    commit("SET_SPRAYING_ATTRIBUTE", value);
  },
  setSecs({ commit }, secs) {
    commit("SET_SECS", secs);
  },
  setDiagnostics({ commit }, value) {
    commit("SET_DIAGNOSTICS", value);
  },
  setDrivingDirection({ commit }, value) {
    commit("SET_DRIVING_DIRECTION", value);
  },
};

const mutations = {
  SET_CONNECTION(state, message) {
    state.connected = message;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_ATTRIBUTE(state, value) {
    state.diagnostics = { ...state.diagnostics, ...value };
  },
  SET_SPRAYING_ATTRIBUTE(state, value) {
    state.sprayingState = { ...state.sprayingState, ...value };
  },
  SET_SECS(state, secs) {
    state.secs = secs;
  },
  SET_DRIVING_DIRECTION(state, value) {
    state.drivingDirection = value;
  },
  SET_DIAGNOSTICS(state, value) {
    state.diagnostics = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
